<template>
    <div>

        <div v-if="loading" class="text-center">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>
        <div v-else>
            <vue-headful :title="`Edit: ${account.ClientName} :: MeritEHS`" v-if="SmartBizClientId" />
            <vue-headful :title="`New Account :: MeritEHS`" v-else />

            <h4 class="py-3 mb-4">
                <ol class="breadcrumb font-weight-bold m-0">
                    <li class="breadcrumb-item font-weight-light">
                        <router-link :to="`/resellers/accounts`">
                            <i class="fa fa-sitemap"></i> Reseller Accounts
                        </router-link>
                    </li>
                    <template v-if="SmartBizClientId">
                        <li class="breadcrumb-item font-weight-light">
                            <router-link :to="`/resellers/accounts/view/${account.SmartBizClientId}`">
                                {{ account.ClientName }}
                            </router-link>
                        </li>
                        <li class="breadcrumb-item active">
                            Edit
                        </li>
                    </template>
                    <li class="breadcrumb-item active" v-else>
                        New Account
                    </li>
                </ol>
            </h4>

            <div class="row">
                <div class="col-lg-8">
                    <div class="card mb-4">
                        <div class="card-header">Account Details</div>
                        <div class="card-body">
                            <div class="row form-group">
                                <label :class="{'col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.ClientName}">Client Name:</label>
                                <div class="col-sm-8">
                                    <input type="text" name="ClientName" v-model="account.ClientName" :class="{'form-control': true, 'is-invalid': errors.ClientName}" placeholder="Enter Client Name (Required)" />
                                    <span v-if="errors.ClientName" class="text-danger">
                                        <span v-for="error in errors.ClientName">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                            <div class="row form-group">
                                <label :class="{'col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.IsActive}">Active:</label>
                                <div class="col-sm-8">
                                    <b-form-checkbox v-model="account.IsActive" :value="1" :unchecked-value="0" plain />
                                    <span v-if="errors.IsActive" class="text-danger">
                                        <span v-for="error in errors.IsActive">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                            <div class="row form-group" v-if="false">
                                <label :class="{'col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.has_paid}">Has Paid:</label>
                                <div class="col-sm-8">
                                    <b-form-checkbox v-model="account.has_paid" :value="1" :unchecked-value="0" plain />
                                    <span v-if="errors.has_paid" class="text-danger">
                                        <span v-for="error in errors.has_paid">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                            <div class="row form-group">
                                <label :class="{'col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.enable_public_insp_forms}">Enable Public Inspections:</label>
                                <div class="col-sm-8">
                                    <b-form-checkbox v-model="account.enable_public_insp_forms" :value="1" :unchecked-value="0" plain />
                                    <span v-if="errors.enable_public_insp_forms" class="text-danger">
                                        <span v-for="error in errors.enable_public_insp_forms">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                            <div class="row form-group">
                                <label :class="{'col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.enable_module_custom_forms}">Enable Custom Forms:</label>
                                <div class="col-sm-8">
                                    <b-form-checkbox v-model="account.enable_module_custom_forms" :value="1" :unchecked-value="0" plain />
                                    <span v-if="errors.enable_module_custom_forms" class="text-danger">
                                        <span v-for="error in errors.enable_module_custom_forms">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="card mb-4">
                        <div class="card-header">Branding & SSO</div>
                        <div class="card-body">
                            <div class="row form-group mb-4">
                                <label :class="{'col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.brand_name}">
                                    Brand Name:
                                </label>
                                <div class="col-sm-8">
                                    <b-form-input v-model="account.brand_name" :class="{'form-control mb-1': true, 'is-invalid': errors.brand_name}" placeholder="Enter Account Brand Name" />

                                    <div class="alert alert-info">
                                        If set, this will be displayed in the Top Navigation bar, before the Global Search box. See example below:
                                    </div>

                                    <div class="">
                                        <img src="/Images/brand-name-example.png" class="img-fluid" />
                                    </div>

                                    <span v-if="errors.brand_name" class="text-danger">
                                        <span v-for="error in errors.brand_name">{{ error }}</span>
                                    </span>
                                </div>
                            </div>

                            <div class="row form-group mb-4">
                                <label :class="{'col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.subdomain}">
                                    Brand Subdomain:
                                </label>
                                <div class="col-sm-8">
                                    <b-form-input v-model="account.subdomain" :class="{'form-control mb-1': true, 'is-invalid': errors.subdomain}" placeholder="Enter Account Subdomain" />

                                    <div class="alert alert-info">
                                        This will be the unique login & access URL for this account example: https://<strong>myaccount</strong>.meritehs.com
                                    </div>

                                    <span v-if="errors.subdomain" class="text-danger">
                                        <span v-for="error in errors.subdomain">{{ error }}</span>
                                    </span>
                                </div>
                            </div>

                            <div class="row form-group mb-4">
                                <label :class="{'col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.login_type}">
                                    Default Login Type
                                </label>
                                <div class="col-sm-8">
                                    <b-form-select v-model="account.login_type" :options="loginTypeOptions" :class="{'form-control mb-1': true, 'is-invalid': errors.login_type}" />

                                    <div class="alert alert-info">
                                        Single Sign On login types still allow email/password users on the account
                                    </div>

                                    <span v-if="errors.login_type" class="text-danger">
                                        <span v-for="error in errors.login_type">{{ error }}</span>
                                    </span>
                                </div>
                            </div>

                            <div class="row form-group" v-if="account.login_type === 'graph'">
                                <label :class="{'col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.account_domain}">
                                    SSO Domain <i class="fa fa-asterisk text-danger"></i>
                                </label>
                                <div class="col-sm-8">
                                    <b-form-input v-model="account.account_domain" :class="{'form-control mb-1': true, 'is-invalid': errors.account_domain}" placeholder="Enter Account Domain, Eg. mycompany.com" />

                                    <div class="alert alert-info">
                                        This should be the value after the "@" in the Company's email address, example: user@<strong>mycompany.com</strong>
                                    </div>

                                    <span v-if="errors.account_domain" class="text-danger">
                                        <span v-for="error in errors.account_domain">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="card mb-4">
                        <div class="card-header">Logos</div>
                        <div class="card-body">
                            <div class="row form-group">
                                <label :class="{'col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.brand_logo_large}">
                                    Primary Logo:
                                </label>
                                <div class="col-sm-8">
                                    <b-form-file accept="image/*" v-model="brand_logo_large" :class="{'is-invalid': errors.brand_logo_large}" />

                                    <div class="alert alert-info mt-1">
                                        Used on authentication pages and QR Code pages.
                                    </div>

                                    <span v-if="errors.brand_logo_large" class="text-danger">
                                        <span v-for="error in errors.brand_logo_large">{{ error }}</span>
                                    </span>
                                </div>
                            </div>

                            <div class="row form-group" v-if="account.brand_logo_large">
                                <label class="col-md-3 col-sm-4 col-form-label text-sm-right">
                                    <i>Existing Primary Logo:</i>
                                </label>
                                <div class="col-sm-8">
                                    <img :src="account.brand_logo_large" class="img-fluid" />
                                </div>
                            </div>

                            <hr/>

                            <div class="row form-group">
                                <label :class="{'col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.inci_pdf_logo}">
                                    PDF Logo:
                                </label>
                                <div class="col-sm-8">
                                    <b-form-file accept="image/*" v-model="inci_pdf_logo" :class="{'is-invalid': errors.inci_pdf_logo}" />

                                    <div class="alert alert-info mt-1">
                                        Used on incident, inspection, and other PDF/Report pages.
                                    </div>

                                    <span v-if="errors.inci_pdf_logo" class="text-danger">
                                        <span v-for="error in errors.inci_pdf_logo">{{ error }}</span>
                                    </span>

                                    <div >

                                    </div>
                                </div>
                            </div>

                            <div class="row form-group" v-if="account.inci_pdf_logo">
                                <label class="col-md-3 col-sm-4 col-form-label text-sm-right">
                                    <i>Existing PDF Logo:</i>
                                </label>
                                <div class="col-sm-8">
                                    <img :src="account.inci_pdf_logo" class="img-fluid" />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="card mb-4" v-if="forms.length > 0">
                        <div class="card-header">Clone Inspection Forms</div>
                        <div class="card-body">
                            <b-form-checkbox v-model="clone_all_inspections" :value="true" :unchecked-value="false" plain>
                                -- Clone All Inspection Forms --
                            </b-form-checkbox>

                            <b-form-checkbox
                                v-for="option in forms"
                                v-model="clone_inspections"
                                :key="option.inspection_form_id"
                                :value="option.inspection_form_id"
                                name="clone_inspections"
                                plain>
                                    {{ option.form_name }}
                            </b-form-checkbox>
                        </div>
                    </div>

                    <div class="card mb-4" v-if="roles.length > 0">
                        <div class="card-header">Clone User Roles</div>
                        <div class="card-body">
                            <b-form-checkbox v-model="clone_all_roles" :value="true" :unchecked-value="false" plain>
                                -- Clone All User Roles --
                            </b-form-checkbox>

                            <b-form-checkbox
                                v-for="option in roles"
                                v-model="clone_roles"
                                :key="option.id"
                                :value="option.id"
                                name="clone_roles"
                                plain>
                                    {{ option.name }}
                            </b-form-checkbox>
                        </div>
                    </div>

                    <div class="card mb-4" v-if="false">
                        <div class="card-header">Sending Credits</div>
                        <div class="card-body">
                            <div class="form-group row">
                                <label :class="{'col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.monthly_email_limit}">Email Credits:</label>
                                <div class="col-sm-7">

                                    <b-form-input v-model="account.monthly_email_limit" :class="{'is-invalid': errors.monthly_email_limit}" placeholder="Enter # of Email Credits"></b-form-input>

                                    <span v-if="errors.monthly_email_limit" class="text-danger">
                                        <span v-for="error in errors.monthly_email_limit">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label :class="{'col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.monthly_text_limit}">Text Credits:</label>
                                <div class="col-sm-7">

                                    <b-form-input v-model="account.monthly_text_limit" :class="{'is-invalid': errors.monthly_text_limit}" placeholder="Enter # of Text Credits"></b-form-input>

                                    <span v-if="errors.monthly_text_limit" class="text-danger">
                                        <span v-for="error in errors.monthly_text_limit">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <button type="button" class="btn btn-success" v-on:click="saveAccount()" :disabled="saving">
                <template v-if="account.SmartBizClientId">Update</template>
                <template v-else>Create</template>
                Account
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                loading: true,
                saving: false,
                SmartBizClientId: this.$route.params.id,
                query: this.$route.query,
                account: {},
                user: {},
                errors: {},
                userTimezone: this.$store.state.user.timezone,
                dateTimeOptions: {
                    format: 'MM/DD/YYYY hh:mm A',
                    useCurrent: false,
                    timeZone: this.$store.state.user.timezone,
                },
                prepaidOptions: {
                    format: 'MM/DD/YYYY',
                    useCurrent: false,
                },
                default_monthly_email_limit: null,
                default_monthly_text_limit: null,
                brand_logo_large: null,
                inci_pdf_logo: null,

                clone_all_inspections: false,
                clone_inspections: [],

                clone_all_roles: false,
                clone_roles: [],
            }
        },

        watch: {
            clone_all_inspections(newVal, oldVal)
            {
                //Check it
                if(newVal == true)
                {
                    //Push all
                    for (var i = 0; i < this.forms.length; i++)
                    {
                        this.clone_inspections.push(this.forms[i].inspection_form_id);
                    }
                }
                else
                {
                    //Reset it?
                    this.clone_inspections = [];
                }
            },

            clone_all_roles(newVal, oldVal)
            {
                //Check it
                if(newVal == true)
                {
                    //Push all
                    for (var i = 0; i < this.roles.length; i++)
                    {
                        this.clone_roles.push(this.roles[i].id);
                    }
                }
                else
                {
                    //Reset it?
                    this.clone_roles = [];
                }
            },
        },

        computed: {
            loginTypeOptions(){
                //Setup
                return [
                    {value: null, text: '-- Select Login Type --'},
                    {value: 'basic', text: 'Email/Password'},
                    {value: 'graph', text: 'Single Sign On - Office365'},
                ];

                //Send options
                return options;
            },
        },


        methods: {

            getAccount() {
                //Get the data
                this.$http
                    .get('resellers/accounts/edit' + (this.SmartBizClientId ? '/' + this.SmartBizClientId : ''), this.query)
                    .then(response => {
                        //Set all the data
                        this.account = response.data.account;
                        this.default_monthly_email_limit = response.data.default_monthly_email_limit;
                        this.default_monthly_text_limit = response.data.default_monthly_text_limit;

                        //Used for NEW Accounts
                        this.forms = response.data.forms;
                        this.roles = response.data.roles;

                        //Set loading
                        this.loading = false;
                    })
                    .catch(response => {

                    });
            },

            saveAccount() {
                //SHow loading
                this.saving = true;

                //Reset the errors
                this.errors = {};

                //Build the payload
                let payload = {...this.account, ...this.user};

                //Append Inspections
                payload.clone_inspections = this.clone_inspections;
                payload.clone_roles = this.clone_roles;

                //Build the images
                let images = {
                    brand_logo_large: this.brand_logo_large,
                    inci_pdf_logo: this.inci_pdf_logo
                };

                //Send it
                this.$http
                .postWithFiles('resellers/accounts/edit', payload, images)
                .then(response => {
                    //Alert the user?
                    this.$toastr.success('Account Saved');

                    //Return to main list?
                    this.$router.push('/resellers/accounts/view/' + response.data.SmartBizClientId);
                })
                .catch(error => {
                    //Check for error
                    if(error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data
                    }
                })
                .then(response => {
                    //SHow loading
                    this.saving = false;
                });
            }
        },

        mounted() {
            //Get the incidents
            this.getAccount();
        }
    }
</script>
